type WithOptionalPlz = { pharmacyPlz?: unknown }

export const hasFullPharmacySlug = (params: WithOptionalPlz) => Boolean(params.pharmacyPlz)

const fullToShortPharmacyRouteName = {
  'apotheke-pharmacyName-pharmacyPlz-pharmacyId': 'apotheke-pharmacyId-short',
  'pharmacyName-pharmacyPlz-pharmacyId-rezept-upload': 'pharmacyId-rezept-upload',
  'pharmacyName-pharmacyPlz-pharmacyId-produkte': 'pharmacyId-produkte',
  'pharmacyName-pharmacyPlz-pharmacyId-produkt-productName-pzn': 'pharmacyId-produkt-productName-pzn',
  'pharmacyId-category': 'pharmacyId-category-short',
  'pharmacyId-manufacturer': 'pharmacyId-manufacturer-short',
} as const

export type FullPharmacyRouteName = keyof typeof fullToShortPharmacyRouteName

export const resolvePharmacyRouteName = <T extends FullPharmacyRouteName>(fullName: T, params: WithOptionalPlz) => {
  return hasFullPharmacySlug(params) ? fullName : fullToShortPharmacyRouteName[fullName]
}
